import React from "react";
import './StateBadge.scss'
import { TidStatusDto } from "../../models/TidStatusDto";

export default class StateBadge extends React.Component<any, any>{
    private badgeStateText: string = '';
    private badgeStateColor: string = '';

    render() {
        switch (this.props.userState) {
            case TidStatusDto.ACTIVE:
                this.badgeStateText = 'ATTIVO';
                this.badgeStateColor = '#0B8252';
                break;
            case TidStatusDto.NOT_ASSIGNED:
                this.badgeStateText = this.props.badgeStateText ? this.props.badgeStateText : 'nessun ID terminale assegnato';
                this.badgeStateColor = '#767676';
                break;
            case TidStatusDto.SUSPENDED:
                this.badgeStateText = 'DISATTIVO';
                this.badgeStateColor = '#C83936';
                break;
        }

        return (
            <div
                className="badge-element-main-style"
                style={{
                    backgroundColor: this.badgeStateColor
                }}
            >
                <p className="badge-element-text">{this.badgeStateText.toUpperCase()}</p>
            </div>
        );
    }
}